<input type="text" class="form-control" placeholder="Search" (keyup)="searchNgxDatatable($event, 'lead_id,agent_name,alias,prospect_company,campaign_name')" />

<div class="row">
	<div class="col-6">
		<app-column-selector [columns]="columns"></app-column-selector>
	</div>
	<div class="col-6" align="right">
		<button class="btn btn-primary btn-sm show-btn" (click)="toogleShowInactiveCampaigns()" *ngIf="!showInactiveCampaigns">Show Inactive Campaigns</button>
		<button class="btn btn-primary btn-sm show-btn" (click)="toogleShowInactiveCampaigns()" *ngIf="showInactiveCampaigns">Hide Inactive Campaigns</button>
	</div>
</div>
<div class="table-responsive">
	<table class="cc-table-notpayed">
		<thead>
			<tr>
				<th class="col-idx">#</th>
				<th *ngIf="showHideColumns('agent_name')">Agent</th>
				<th *ngIf="showHideColumns('alias')">Alias</th>
				<th *ngIf="showHideColumns('prospect_company')">Prospect</th>
				<th>Campaign</th>
				<th *ngIf="showHideColumns('isReserve')" class="text-center">Reserve</th>
				<th>Options</th>
			</tr>
		</thead>

		<tbody>
			<tr *ngIf="loading">
				<td [attr.colspan]="7" class="text-center py-4">
					<div class="spinner-border text-primary spinner-border-sm" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</td>
			</tr>

			<tr *ngFor="let row of notPayedLeads">
				<td class="col-idx">{{ row.lead_id }}</td>

				<td *ngIf="showHideColumns('agent_name')">{{ row.agent_name }}</td>
				<td *ngIf="showHideColumns('alias')">{{ row.alias }}</td>
				<td *ngIf="showHideColumns('prospect_company')">{{ row.prospect_company }}</td>

				<td [ngClass]="getCellClassCampaign({ row: row })">
					<span class="badge clickable" [ngClass]="row['campaign_active'] == '1' ? 'bg-success' : 'bg-danger'" (click)="editCampaign(row['campaign_id'])">
						<i class="ri-check-line" title="Active campaign" *ngIf="row['campaign_active'] == '1'"></i>
						<i class="ri-close-line" title="Inactive campaign" *ngIf="row['campaign_active'] != '1'"></i>
						{{ row["campaign_name"] }}
					</span>
				</td>

				<td *ngIf="showHideColumns('isReserve')" class="text-center">
					<span class="badge bg-dark-subtle text-body" *ngIf="row['isReserve'] == 'F' || row['isReserve'] == ''"> ... </span>
					<span class="badge bg-danger" *ngIf="row['isReserve'] == 'T'"> Reserve </span>
				</td>

				<td [ngClass]="getCellClassOptions({ row: row })">
					<!-- AUTHORIZE BUTTONS -->
					<button class="btn btn-dark waves-effect waves-light btn-sm me-1" (click)="setAuthorizeCard(row)" *ngIf="payment_provider == 'Authorize' && (row['authorize_id'] == '' || row['authorize_id'] == null || row['authorize_id'] == undefined)">Set new card</button>
					<button class="btn btn-dark waves-effect waves-light btn-sm me-1" (click)="warningCharge(row)" *ngIf="payment_provider == 'Authorize' && row['authorize_id'] !== '' && row['authorize_id'] !== null && row['authorize_id'] !== undefined">Charge</button>

					<!-- CHASE AUTHORIZE BUTTONS -->
					<button class="btn btn-dark waves-effect waves-light btn-sm me-1" (click)="setAuthorizeCard(row)" *ngIf="payment_provider == 'chase' && (row['chase_authorize_id'] == '' || row['chase_authorize_id'] == null || row['chase_authorize_id'] == undefined)">Set new card</button>
					<button class="btn btn-dark waves-effect waves-light btn-sm me-1" (click)="warningCharge(row)" *ngIf="payment_provider == 'chase' && row['chase_authorize_id'] !== '' && row['chase_authorize_id'] !== null && row['chase_authorize_id'] !== undefined">Charge</button>

					<!-- BILL.COM ACH BUTTONS -->
					<button class="btn btn-success waves-effect waves-light btn-sm me-1" (click)="chargeAchLead(row)" *ngIf="payment_provider == 'Authorize' && row['billcom_bank_account_id'] && row['billcom_bank_account_id'] != ''">Charge ACH</button>
					<button class="btn btn-warning waves-effect waves-light btn-sm" (click)="freeLeadModal(free_lead, row)">Free</button>
				</td>
			</tr>

			<tr *ngIf="!loading && notPayedLeads.length === 0">
				<td [attr.colspan]="7" class="text-center py-4 text-muted">No records found.</td>
			</tr>
		</tbody>

		<tfoot>
			<tr>
				<td [attr.colspan]="7">
					<strong class="footer-totals">Total Records: {{ notPayedLeads.length }}</strong>
				</td>
			</tr>
		</tfoot>
	</table>
</div>
<!-- MODAL WARNING CHARGE -->
<ng-template #chargingModal let-modal id="chargingModal">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Charge Lead</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<p style="font-size: 20px">
			Charging to alias <strong>{{ selectedLead.alias }}</strong> from campaign <strong>{{ selectedLead.campaign_name }}</strong>
		</p>
		<div *ngIf="loadingCard" align="center">
			<div class="spinner-border text-primary" role="status">
				<span class="sr-only">Loading...</span>
			</div>
			<p>Loading prices...</p>
		</div>

		<select class="form-control" [(ngModel)]="selectedCost" *ngIf="!loadingCard" style="font-size: 20px">
			<option *ngFor="let price of prices" [value]="price.description + ' - ' + price.price">
				{{ price.description }} - <strong>{{ price.price | currency: "USD" }}</strong>
			</option>
		</select>
		<br />

		<div *ngIf="!loadingCard && payment_provider == 'NMI'">
			<p class="placeholder-glow cards-text">
				<strong>Card to charge:</strong> <br />
				<span class="placeholder col-6" *ngIf="loadingCard"></span>
				<span *ngIf="!loadingCard && cardToPay != 'There isnt default credit card for this user'" style="font-size: 25px">●●●● ●●●● ●●●● {{ cardToPay }}</span>
				<span *ngIf="!loadingCard && cardToPay === 'There isnt default credit card for this user'" style="font-size: 15px">{{ cardToPay }}</span>
			</p>
			<p class="cards-text">
				<strong>Nmi Customer ID:</strong> <br />
				<span style="font-size: 25px">{{ selectedLead.cus_id }}</span>
				<span class="copy-btn"
					><button class="btn btn-sm btn-dark" (click)="copyToClipboard()" title="Copy Customer Id">
						<i class="bx bx-check" *ngIf="copied"></i>
						<i class="bx bx-clipboard" *ngIf="!copied"></i></button
				></span>
			</p>
			<br />
			<p class="cards-text">If you need to use different card use this ID to add new cards., add the new card directly on NMI, and set it as priority payment method.</p>
			<!-- <button class="btn btn-sm btn-outline-secondary" (click)="addNewCard(addNewCardModal)">Add new Card</button> -->
		</div>
	</div>
	<div class="modal-footer">
		<!-- NMI Charge Button  -->
		<button type="button" class="btn btn-dark waves-effect waves-light" (click)="chargeOfficial()" [disabled]="loadingCharge" *ngIf="payment_provider == 'NMI'">Charge</button>
		<!-- AUTHORIZE CHARGE BUTTON -->
		<button type="button" class="btn btn-dark waves-effect waves-light" (click)="chargeAuthorizeNet()" [disabled]="loadingCharge" *ngIf="payment_provider == 'Authorize' && !isAchCharge">Charge</button>
		<!-- CHASE CHARGE BUTTON -->
		<button type="button" class="btn btn-dark waves-effect waves-light" (click)="chargeAuthorizeNet(true)" [disabled]="loadingCharge" *ngIf="payment_provider == 'chase'">Charge</button>
		<!-- BILL.COM ACH CHARGE BUTTON -->
		<button type="button" class="btn btn-success waves-effect waves-light" (click)="chargeAch()" [disabled]="loadingCharge" *ngIf="payment_provider == 'Authorize' && isAchCharge">Charge ACH</button>
	</div>
</ng-template>

<!-- MODAL FREE LEAD -->
<ng-template #free_lead let-modal id="free_lead">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Free Lead</h4>
		<p>Are you sure you want to mark this lead as free?</p>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="form-group">
			<div class="row">
				<div class="col-3" align="center">
					<button class="btn btn-secondary btn-sm" style="background-color: #adadad; border-color: #adadad; color: #333333" (click)="setFreeLead('Hourly')">Hourly</button>
				</div>
				<div class="col-3" align="center">
					<button class="btn btn-primary btn-sm" (click)="setFreeLead('Reserve')">Reserve</button>
				</div>
				<div class="col-3" align="center">
					<button class="btn btn-danger btn-sm" (click)="setFreeLead('Promo')">Promo</button>
				</div>
				<div class="col-3" align="center">
					<button class="btn btn-success btn-sm" (click)="setPayedLead()">Paid</button>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer p-3">
		<button class="btn btn-default btn-sm" (click)="modal.dismiss('Cross click')">CANCEL</button>
	</div>
</ng-template>

<!-- SELECt CUSTOMER ID -->
<ng-template #modalCustomerId let-modal id="Customer_id">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title" *ngIf="loadingPrices">Searching NMI Customer ...</h4>
		<h4 class="modal-title" id="modal-basic-title" *ngIf="!loadingPrices && gettedCustomerNMI.customerId != ''">NMI Customer Found</h4>
		<h4 class="modal-title" id="modal-basic-title" *ngIf="!loadingPrices && gettedCustomerNMI.customerId === ''">NMI Customer Not Found</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="row" *ngIf="!loadingPrices && gettedCustomerNMI.customerId != ''">
			<div class="col-6">
				<label><strong>Customer ID:</strong></label>
				<p>{{ gettedCustomerNMI.customerId }}</p>

				<label><strong>First Name:</strong></label>
				<p>{{ gettedCustomerNMI.first_name }}</p>

				<label><strong>Last Name:</strong></label>
				<p>{{ gettedCustomerNMI.last_name }}</p>

				<label><strong>Address 1:</strong></label>
				<p>{{ gettedCustomerNMI.address_1 }}</p>

				<label><strong>Email:</strong></label>
				<p>{{ gettedCustomerNMI.email }}</p>

				<label><strong>Company:</strong></label>
				<p>{{ gettedCustomerNMI.company }}</p>
			</div>
			<div class="col-6">
				<label><strong>City:</strong></label>
				<p>{{ gettedCustomerNMI.city }}</p>

				<label><strong>State:</strong></label>
				<p>{{ gettedCustomerNMI.state }}</p>

				<label><strong>Postal Code:</strong></label>
				<p>{{ gettedCustomerNMI.postal_code }}</p>

				<label><strong>Country:</strong></label>
				<p>{{ gettedCustomerNMI.country }}</p>

				<label><strong>Phone:</strong></label>
				<p>{{ gettedCustomerNMI.phone }}</p>

				<label><strong>Credit Card Number:</strong></label>
				<p>{{ gettedCustomerNMI.cc_number }}</p>
			</div>
		</div>

		<div *ngIf="loadingPrices" align="center">
			<div class="spinner-border text-primary" role="status">
				<span class="sr-only">Loading...</span>
			</div>
		</div>
	</div>

	<div class="modal-footer p-3" *ngIf="!loadingPrices">
		<button type="button" class="btn btn-dark waves-effect waves-light" (click)="linkCustomer()" *ngIf="!loadingPrices && gettedCustomerNMI.customerId != ''" [disabled]="loadingPrices">Link NMI Customer with LMS Customer</button>
		<button type="button" class="btn btn-dark waves-effect waves-light" (click)="collectCheckout()" *ngIf="!loadingPrices && gettedCustomerNMI.customerId === ''" [disabled]="loadingPrices">Create new Customer</button>
	</div>
</ng-template>

<!-- MODAL ADD NEW CARD -->
<ng-template #addNewCardModal let-modal id="addNewCardModal">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Add New Card</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<form #cardForm="ngForm">
			<div class="row">
				<div class="col-12">
					<label for="cardNumber" class="form-label">Card Number</label>
					<input type="text" class="form-control" id="cardNumber" name="cardNumber" ngModel required />
				</div>
				<div class="col-6">
					<label for="cardHolder" class="form-label">Firstname</label>
					<input type="text" class="form-control" id="first_name" placeholder="Firstname" name="first_name" ngModel required />
				</div>
				<div class="col-6">
					<label for="cardHolder" class="form-label">Lastname</label>
					<input type="text" class="form-control" id="last_name" placeholder="Lastname" name="last_name" ngModel required />
				</div>
				<div class="col-12">
					<label for="expiryDate" class="form-label">Expiry Date</label>
					<input type="text" class="form-control" id="expiryDate" name="expiryDate" ngModel required placeholder="MM/YY" />
				</div>
				<div class="col-12">
					<label for="billingAddress" class="form-label">Billing Address</label>
					<input type="text" class="form-control" id="billingAddress" name="billingAddress" ngModel required />
				</div>
				<div class="col-12">
					<label for="postalCode" class="form-label">Postal Code</label>
					<input type="text" class="form-control" id="postalCode" name="postalCode" ngModel required />
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cross click')">Cancel</button>
		<button type="button" class="btn btn-primary" (click)="submitCardForm(cardForm)" [disabled]="cardForm.invalid">Add Card</button>
	</div>
</ng-template>
